import { useQuery } from '@tanstack/react-query'

import { TaxList, TaxListParams } from '@/api/_schemas/management'
import {
  getCfopList,
  getIcmsModalidadeList,
  getIcmsOrigemList,
  getIcmsSituacaoList,
  getNcmList,
  getPisCofinsSituacaoList,
  getPisCofinsTipoList,
} from '@/api/management'
import { TaxKeyItem } from '@/app/panel/management/price-list/_schemas/update-product-types'
import { keyStore } from '@/config/key-store'

const taxFunctions: Record<
  TaxKeyItem,
  (params: TaxListParams) => Promise<TaxList>
> = {
  cfopList: getCfopList,
  ncmList: getNcmList,
  icmsModalidadeList: getIcmsModalidadeList,
  icmsOrigemList: getIcmsOrigemList,
  icmsSituacaoList: getIcmsSituacaoList,
  pisCofinsTipoList: getPisCofinsTipoList,
  pisCofinsSituacaoList: getPisCofinsSituacaoList,
}

function useTaxList(
  taxKeyItem: TaxKeyItem,
  enabled: boolean,
  searchParam?: string,
) {
  const search = searchParam || undefined

  return useQuery({
    queryKey: [...keyStore.tax[taxKeyItem].queryKey, search],
    queryFn: async () => await taxFunctions[taxKeyItem]({ search }),
    refetchOnMount: false,
    staleTime: Infinity,
    enabled,
  })
}

export { useTaxList }
